
interface GuestFormProps {
  name: string;
  email: string;
  phone: string;
  address: string;
  state: string;
  gender: string;
  setName: (val: string) => void;
  setEmail: (val: string) => void;
  setPhone: (val: string) => void;
  setAddress: (val: string) => void;
//   setState: (val: string) => void;
//   setNationality: (val: string) => void;
  setGender: (val: string) => void;
}

export const GuestForm: React.FC<GuestFormProps> = ({
  name, email, phone, address, state, gender,
  setName, setEmail, setPhone, setAddress, setGender,
//    setState, setNationality, 
}) => {

  return (
    <div className="space-y-4 mb-4 mt-4">
      <h3 className="text-lg font-medium text-gray-700">Guest Information 📝</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <input
          type="text"
          placeholder="Full Name / Organisation"
          value={name}
          onChange={(e) => setName(e.target.value)}
          className="p-3 border rounded-lg focus:ring focus:ring-blue-300"
        />
        <input
          type="email"
          placeholder="Email (Optional)"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="p-3 border rounded-lg focus:ring focus:ring-blue-300"
        />
        <input
          type="tel"
          placeholder="Phone Number"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          className="p-3 border rounded-lg focus:ring focus:ring-blue-300"
        />
        <input
          type="text"
          placeholder="Address"
          value={address}
          onChange={(e) => setAddress(e.target.value)}
          className="p-3 border rounded-lg focus:ring focus:ring-blue-300"
        />
        <select
          value={gender}
          onChange={(e) => setGender(e.target.value)}
          className="p-3 border rounded-lg focus:ring focus:ring-blue-300"
        >
          <option value="">Select Gender</option>
          <option value="male">Male</option>
          <option value="female">Female</option>
        </select>
      </div>
    </div>
  );
};